/** Header exigido por la API para peticiones mutables con cookies (mitigación CSRF). */
export const CSRF_REQUEST_HEADERS = {
  'X-Requested-With': 'XMLHttpRequest',
} as const;

export function withCsrfHeaders(headers?: HeadersInit): HeadersInit {
  return { ...CSRF_REQUEST_HEADERS, ...headers };
}
